export default {
      id: "icon--filtering-usage",
      viewBox: "0 0 29 27",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--filtering-usage",
      toString: function () {
        return this.url;
      }
    }